export default {
    methods: {
        getBloodType(bIndex) {
            if(bIndex === 1) return 'A+'
            else if(bIndex === 2) return 'A-'
            else if(bIndex === 3) return 'B+'
            else if(bIndex === 4) return 'B-'
            else if(bIndex === 5) return 'AB+'
            else if(bIndex === 6) return 'AB-'
            else if(bIndex === 7) return 'O+'
            else if(bIndex === 8) return 'O-'
        },
        getGender(gIndex){
            if(gIndex === 1) return 'Male'
            else if(gIndex === 2) return 'Female'
        }
    }
}